import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import {
  EUserGroupsListActions,
  GetUserGroups,
  GetUserGroupsSuccess,
  ResetUserGroups,
  ResetUserGroupsSuccess,
  DeleteUserGroups,
  DeleteUserGroupsSuccess
} from '../actions/user-groups-list.actions';
import { UserGroupsService } from '../../user-groups.service';
import { ResetCurrentUserGroup } from '../actions/current-user-group.actions';
import { Store } from '@ngrx/store';
import { ResetProperties } from 'app/core/store/actions/pending-changes.actions';
import { IAppState } from 'app/IAppState';

@Injectable()
export class UserGroupsListEffects {

  uploadBexFile$ = createEffect(() =>
    this._actions$.pipe(
      ofType<GetUserGroups>(EUserGroupsListActions.GetUserGroups),
      switchMap(() => this._userGroupsService.get()),
      switchMap((userGroupsList: IUserGroup[]) => of(new GetUserGroupsSuccess(userGroupsList)))
    )
  );
  resetUserGroup$ = createEffect(() =>
    this._actions$.pipe(
      ofType<ResetUserGroups>(EUserGroupsListActions.ResetUserGroups),
      switchMap(() => of(new ResetUserGroupsSuccess()))
    )
  );
  deleteUserGroups$ = createEffect(() =>
    this._actions$.pipe(
      ofType<DeleteUserGroups>(EUserGroupsListActions.DeleteUserGroups),
      switchMap((param) => {
        return this._userGroupsService.delete(param.payload);
      }),
      switchMap(() => [new GetUserGroups(), new DeleteUserGroupsSuccess()])
    )
  );
  resetCurrentUserGroup$ = createEffect(() =>
    this._actions$.pipe(
      ofType<DeleteUserGroupsSuccess>(EUserGroupsListActions.DeleteUserGroupsSuccess),
      switchMap(() => {
        this._store.dispatch(new ResetProperties());
        return of(new ResetCurrentUserGroup());
      })
    )
  );

  constructor(
    private _userGroupsService: UserGroupsService,
    private _actions$: Actions,
    private _store: Store<IAppState>
  ) {
  }
}
